import styles from './ControlsPanel.module.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { ExcludeSwitch } from '../../../pages/SearchPage/Filter/ExcludeSwitch';
import React from 'react';

interface FilterControlsPanelProps {
  id: string;
  count: number;
  isExclude: boolean;
  showExcludeSwitch?: boolean;
  showSelectAll?: boolean;
  isSelectAllDisabled?: boolean;
  onClearAll: () => void;
  onSelectAll?: () => void;
  onExcludeClick?: () => void;
}

export const ControlsPanel: React.FC<FilterControlsPanelProps> = ({
  count,
  isExclude,
  showExcludeSwitch=false,
  showSelectAll=true,
  isSelectAllDisabled=false,
  id,
  onClearAll,
  onSelectAll,
  onExcludeClick,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.filterControlsPanel}>
      <div className={styles.buttonsContainer}>
        <div className={styles.countText}>
          {t('filters selected', { count })}
        </div>
        {showSelectAll ? <button className={styles.controlButton} onClick={onSelectAll} disabled={isSelectAllDisabled}>
          {t('Select All')}
        </button> : ''}
        <button className={styles.controlButton} onClick={onClearAll} disabled={count === 0}>
          {t('Clear')}
        </button>
      </div>
      {showExcludeSwitch ? <div className={styles.excludeSwitch}>
        <ExcludeSwitch
          id={id}
          value={isExclude}
          color="red"
          onChange={onExcludeClick}
          direction="row-reverse"
        />
      </div> : ''}
    </div>
  );
};
